
import { getStripeData, getStripeDetails } from '../../apis/stripe';
import store from '../../utils/store';

export const getDataFromStripe = async () => {
  const { paymentTypes, shopId, isAllShops } = store.getState().user;
  let ifGetStripe = false;
  paymentTypes &&
    paymentTypes.forEach(type => {
      ifGetStripe = type === 'stripe' ? true : ifGetStripe;
    });
  const balances = ifGetStripe ? await getStripeData(!isAllShops ? shopId : null, isAllShops) : [];
  return balances;
};
export const getDataFromStripeDetails = async (transactionId, automatic, component) => {
  try {
    component.setState({ isLoading: true })
    const { shopId } = store.getState().user;
    const details = await getStripeDetails(shopId, automatic, transactionId);
    component.setState({ details, isLoading: false });
  } catch (error) {
    component.setState({ isLoading: false })
    console.error('Il y a eu une erreur lors de la récupération des détails du virement.', error);

  }
};

